import { isFromApp } from 'utils/isFromApp';
import { throwOrLog } from 'utils/env';

export const storageEvent = new Event('storage');

export function dispatchStorageEvent() {
  window.dispatchEvent(storageEvent);
}

export function setLocalStorage(key: string, value: unknown) {
  try {
    window.localStorage.setItem(key, JSON.stringify(value));

    if (isFromApp) {
      dispatchStorageEvent();
    }
  } catch (error) {
    throwOrLog((error as Error).message);
  }
}

export function getLocalStorage<T>(key: string): T | undefined;
export function getLocalStorage<T>(key: string, defaultValue: T): T;
export function getLocalStorage<T>(key: string, defaultValue?: T): T | undefined {
  try {
    const item = localStorage.getItem(key);
    if (item === null) {
      return defaultValue;
    }
    return JSON.parse(item) as T;
  } catch {
    return defaultValue;
  }
}
